import Axios from 'axios'
import * as actionTypes from './actionTypes'
import { push } from 'react-router-redux'
import * as uiActions from './uiActions'

const API_URL = 'https://api.integrada.ind.br/api'

export const loginSuccess = (token) => {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    payload: {
      token
    }
  }
}

export const loginError = (error) => {
  return {
    type: actionTypes.LOGIN_ERROR,
    payload: error,
    error: true
  }
}

export const loginLoading = () => {
  return {
    type: actionTypes.LOGIN_LOADING,
    payload: {}
  }
}

export const login = (user) => {
  return (dispatch) => {
    if (!user.username && !user.password) {
      return dispatch(uiActions.showSnackbar('Informe suas credenciais.'))
    }

    if (!user.username) {
      return dispatch(uiActions.showSnackbar('Informe sua nome de usuário.'))
    }

    if (!user.password) {
      return dispatch(uiActions.showSnackbar('Informe sua senha.'))
    }

    dispatch(loginLoading())
    Axios.post(`${API_URL}/auth/token/`, user)
      .then(response => {
        dispatch(loginSuccess(response.data.token))
        dispatch(uiActions.hideSnackbar())
        dispatch(push('/'))
      })
      .catch(error => {
        dispatch(uiActions.showSnackbar('Não foi possível confirmar suas credenciais.'))
        dispatch(loginError(error))
      })
  }
}

export const logout = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.LOGOUT,
      payload: {}
    })
    dispatch(push('/login'))
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/authActions.js
 **/